import { buildWebOrigin } from 'utils/webOrigin';

function parentId(row) {
  if (!row.parent) return 'root';
  if (typeof row.parent === 'object' && row.parent._id) return String(row.parent._id);
  return String(row.parent);
}

/**
 * Canonical HTTPS URL for Shared Documents deep linking (web + mobile).
 * Documents: `/home/documents/shared/{parentFolderId}/{documentId}` (`parentFolderId` is `root` when at shared root).
 * Folders: `/home/documents/shared/{folderId}/`
 *
 * @param {object} company — must include subDomain
 * @param {object} row — Shared file row with _id, kind, optional parent
 * @returns {string|null}
 */
export default function getSharedFileLink(company, row) {
  if (!company?.subDomain || !row?._id) return null;
  const origin = buildWebOrigin(company.subDomain);
  const base = `${origin}/home/documents/shared`;

  if (row.kind === 'Folder') {
    return `${base}/${row._id}/`;
  }
  if (row.kind === 'Document') {
    return `${base}/${parentId(row)}/${row._id}`;
  }
  return null;
}
